import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import {WorkflowdashboardService} from 'app/services/workflowdashboard.service';

@Component({
  selector: 'app-workflowdashboard',
  templateUrl: './workflowdashboard.component.html',
  styleUrls: ['./workflowdashboard.component.css']
})
export class WorkflowdashboardComponent implements OnInit {

  vFlows: any = [];
  isRemove = false;
  removeRef: any;
  
  page = 1;
  lblHeading = '';

  popoverTitle = 'Delete Workflow';
  popoverMessage = 'Are you sure you want to delete Workflow?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Workflows...";

  public isLoading = false;
  isEmpty: boolean = false;

  constructor(private wservice: WorkflowdashboardService,
     public utility: UtilityServiceService) { }

  ngOnInit() {
    //load the screen
    this.onChangeHeading();
    this.reload(); 
  }
  reload() {
    this.isLoading = true;
    this.wservice.getDashBoard().subscribe(result => {
      this.vFlows = result;
      
      //console.log(this.vFlows);
      this.isLoading = false;
    }, error => {
      console.dir(error);
      this.isLoading = false;
      this.isEmpty = true;
    });
  }
  onDelete(id: any) {
    
    /* this.service.delete(id).subscribe(result => {

      this.dialogService.addDialog(AlertComponent, { title: 'Delete Vehicle Make', message: `Vehicle Make ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      this.dialogService.addDialog(ErrorComponent, { title: 'Delete Vehicle Make', message: `Vehicle Make ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
    }); */
  }
  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Workflow <strong>${this.removeRef.WorkflowName}</strong>?`;
    this.onChangeHeading(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeading();
  }

  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'Workflow' : 'Delete Workflow';
  }
}
